import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import InstructionsCheckbox from 'components/Input/InstructionsCheckboxInput';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import { apiTokenInstructions, getProviderFormLabel } from '../utils';
import { SwitchImplementationButton } from 'components/LinkButton/LinkButton';

const SignInZenefitsApi = ({
  provider,
  client,
  isLoading,
  onSubmit,
  handleClick,
  instructionsLink,
}: RegisterImplementationProps) => {
  const instructions = apiTokenInstructions(provider.displayName, client);

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      instructionsLink={instructionsLink}
      divider
      onSubmit={onSubmit}
      fieldNames={['instructionCheck', 'apiToken']}
      render={({ instructionCheck, apiToken }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <InstructionsCheckbox
                checked={instructionCheck.value}
                onChange={(checked) => instructionCheck.onChange(checked)}
              />
              <Input
                id="apiToken"
                value={apiToken.value}
                onChange={(event) => apiToken.onChange(event.target.value)}
                invalid={apiToken.invalid}
                label="API Token"
              />
            </MainContainer>
            {handleClick && (
              <SwitchImplementationButton onClick={handleClick} useNewDesign>
                Use a Username and Password instead
              </SwitchImplementationButton>
            )}
            <LoaderButton
              text="Connect"
              isLoading={isLoading}
              disabled={isLoading || !instructionCheck.value || !apiToken.value}
              type="submit"
            />
          </>
        );
      }}
    />
  );
};

export default SignInZenefitsApi;
